(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    

  // ============================================
  // THUMBNAIL CAROUSEL GALLERY - Click to Display
  // ============================================
  (function() {
    'use strict';
    
    function initGalleryCarousel() {
      // Find all gallery carousels on the page
      const galleries = document.querySelectorAll('.gallery-carousel');
      
      galleries.forEach(function(gallery) {
        const mainImg = gallery.querySelector('.gallery-carousel__main-image img');
        const mainImageContainer = gallery.querySelector('.gallery-carousel__main-image');
        const thumbnails = gallery.querySelectorAll('.gallery-carousel__thumbnail');
        const thumbnailsContainer = gallery.querySelector('.gallery-carousel__thumbnails');
        const thumbnailsWrapper = gallery.querySelector('.gallery-carousel__thumbnails-wrapper');
        const prevBtn = gallery.querySelector('.gallery-carousel__nav--prev');
        const nextBtn = gallery.querySelector('.gallery-carousel__nav--next');
        
        if (!mainImg || !thumbnails.length) return;
        
        // Click on thumbnail to change main image
        thumbnails.forEach(function(thumb) {
          thumb.addEventListener('click', function() {
            // Get image source from data attribute
            const newSrc = this.getAttribute('data-src');
            const newAlt = this.getAttribute('data-alt') || '';
            
            // Update main image with fade effect
            mainImg.style.opacity = '0.5';
            
            setTimeout(function() {
              mainImg.src = newSrc;
              mainImg.alt = newAlt;
              mainImg.style.opacity = '1';
            }, 150);
            
            // Update active thumbnail
            thumbnails.forEach(function(t) {
              t.classList.remove('active');
            });
            this.classList.add('active');
            
            // Scroll to make active thumbnail visible
            this.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          });
        });
        
        // Navigation arrows
        if (prevBtn && nextBtn && thumbnailsContainer) {
          const scrollAmount = 200;
          
          prevBtn.addEventListener('click', function() {
            thumbnailsContainer.scrollBy({
              left: -scrollAmount,
              behavior: 'smooth'
            });
          });
          
          nextBtn.addEventListener('click', function() {
            thumbnailsContainer.scrollBy({
              left: scrollAmount,
              behavior: 'smooth'
            });
          });
          
          // Check if scroll is needed
          function checkScrollNeeded() {
            if (thumbnailsContainer.scrollWidth <= thumbnailsContainer.clientWidth) {
              thumbnailsWrapper.classList.add('no-scroll');
            } else {
              thumbnailsWrapper.classList.remove('no-scroll');
            }
          }
          
          checkScrollNeeded();
          window.addEventListener('resize', checkScrollNeeded);
        }
      });
      
      console.log('Thumbnail carousel gallery initialized');
    }
    
    // Run on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGalleryCarousel);
    } else {
      initGalleryCarousel();
    }
    
    // Also run after delay for dynamic content
    setTimeout(initGalleryCarousel, 500);
    
  })();


  // Fix Product Page Button Layout
  (function() {
    'use strict';
    
    function fixButtonLayout() {
      // Find the quantity-cart-row container
      const quantityCartRow = document.querySelector('.quantity-cart-row');
      
      if (!quantityCartRow) {
        console.log('quantity-cart-row not found');
        return;
      }
      
      // Find the product-form that's currently OUTSIDE quantity-cart-row
      const productFormWrapper = quantityCartRow.nextElementSibling;
      
      if (productFormWrapper && productFormWrapper.querySelector('product-form')) {
        console.log('Moving product-form inside quantity-cart-row');
        
        // Move the entire wrapper div into quantity-cart-row
        quantityCartRow.appendChild(productFormWrapper);
        
        // Hide pickup availability inside quantity row
        const pickupAvail = productFormWrapper.querySelector('pickup-availability');
        if (pickupAvail) {
          pickupAvail.style.display = 'none';
        }
      }
      
      // Find and move Buy Now button (shopify-payment-button) AFTER quantity-cart-row
      const paymentButton = document.querySelector('.shopify-payment-button');
      if (paymentButton && quantityCartRow.parentNode) {
        console.log('Moving Buy Now button after quantity-cart-row');
        
        // Create wrapper if it doesn't exist
        let wrapper = document.querySelector('.shopify-payment-button-wrapper');
        if (!wrapper) {
          wrapper = document.createElement('div');
          wrapper.className = 'shopify-payment-button-wrapper';
          wrapper.appendChild(paymentButton);
        }
        
        // Insert after quantity-cart-row
        quantityCartRow.parentNode.insertBefore(wrapper, quantityCartRow.nextSibling);
      }
      
      // Ensure installments button is after Buy Now
      const installmentBtn = document.querySelector('.installment-button-wrapper');
      const buyNowWrapper = document.querySelector('.shopify-payment-button-wrapper');
      
      if (installmentBtn && buyNowWrapper && buyNowWrapper.parentNode) {
        console.log('Moving Installments button after Buy Now');
        buyNowWrapper.parentNode.insertBefore(installmentBtn, buyNowWrapper.nextSibling);
      }
      
      console.log('Button layout fixed successfully!');
    }
    
    // Run on page load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fixButtonLayout);
    } else {
      fixButtonLayout();
    }
    
    // Also run after a short delay to catch dynamic content
    setTimeout(fixButtonLayout, 500);
    setTimeout(fixButtonLayout, 1000);
    
  })();

(function() {
  'use strict';
  
  function updatePriceAndBadge() {
    console.log('Updating price display and sale badge...');
    
    // Find price container
    const priceContainer = document.querySelector('.price');
    if (!priceContainer) {
      console.log('Price container not found');
      return;
    }
    
    // Find current/sale price
    const salePriceElement = priceContainer.querySelector('.price-item--sale');
    const salePriceText = salePriceElement ? salePriceElement.textContent.trim() : '';
    
    // Find compare-at/regular price (original price)
    const regularPriceElement = priceContainer.querySelector('.price__regular .price-item--regular, .price__sale s .price-item--regular, .price__sale .price-item--regular');
    const regularPriceText = regularPriceElement ? regularPriceElement.textContent.trim() : '';
    
    console.log('Sale Price:', salePriceText);
    console.log('Regular Price:', regularPriceText);
    
    // Extract numeric values
    const salePrice = parseFloat(salePriceText.replace(/[^0-9.]/g, ''));
    const regularPrice = parseFloat(regularPriceText.replace(/[^0-9.]/g, ''));
    
    console.log('Sale Price (numeric):', salePrice);
    console.log('Regular Price (numeric):', regularPrice);
    
    // Check if we have a valid discount
    if (regularPrice && salePrice && regularPrice > salePrice) {
      // Calculate discount percentage
      const discountAmount = regularPrice - salePrice;
      const discountPercent = Math.round((discountAmount / regularPrice) * 100);
      
      console.log('Discount Percent:', discountPercent + '%');
      console.log('Discount Amount:', discountAmount);
      
      // Force strikethrough on compare-at-price
      if (regularPriceElement) {
        regularPriceElement.style.textDecoration = 'line-through';
        regularPriceElement.style.color = '#000000';
        
        // Wrap in <s> tag if not already
        if (regularPriceElement.parentElement.tagName !== 'S') {
          const sTag = document.createElement('s');
          regularPriceElement.parentNode.insertBefore(sTag, regularPriceElement);
          sTag.appendChild(regularPriceElement);
        }
      }
      
      // Find or create sale badge
      let saleBadge = priceContainer.querySelector('.price__badge-sale, .badge--sale');
      
      if (!saleBadge) {
        // Create new badge
        saleBadge = document.createElement('span');
        saleBadge.className = 'badge price__badge-sale';
        priceContainer.appendChild(saleBadge);
      }
      
      // Update badge content and show it
      saleBadge.textContent = discountPercent + '% OFF';

      saleBadge.setAttribute('data-discount', discountPercent);
      saleBadge.classList.add('show-badge');
      saleBadge.style.display = 'inline-block';
      
      console.log('Sale badge updated:', saleBadge.textContent);
      
      // Update or create savings text
      let savingsText = document.querySelector('.product__tax.caption, .savings-text');
      
      if (!savingsText) {
        savingsText = document.createElement('p');
        savingsText.className = 'product__tax caption savings-text';
        priceContainer.parentNode.insertBefore(savingsText, priceContainer.nextSibling);
      }
      
      // Update savings text
      const currencySymbol = salePriceText.match(/[^\d.,\s]+/)?.[0] || 'PKR';
      savingsText.textContent = 'Total Saving ' + currencySymbol + ' ' + discountAmount.toFixed(2);
      savingsText.classList.add('show-savings');
      savingsText.style.display = 'block';
      
      console.log('Savings text updated:', savingsText.textContent);
      
    } else {
      // No discount - hide sale badge and savings
      console.log('No valid discount found');
      
      const saleBadge = priceContainer.querySelector('.price__badge-sale, .badge--sale');
      if (saleBadge) {
        saleBadge.style.display = 'none';
        saleBadge.classList.remove('show-badge');
      }
      
      const savingsText = document.querySelector('.product__tax.caption, .savings-text');
      if (savingsText) {
        savingsText.style.display = 'none';
        savingsText.classList.remove('show-savings');
      }
    }
    
    // Hide "Sold out" badge if product is available
    const soldOutBadge = document.querySelector('.badge--sold-out, .price__badge-sold-out');
    if (soldOutBadge) {
      const addToCartBtn = document.querySelector('.product-form__submit');
      if (addToCartBtn && !addToCartBtn.disabled) {
        soldOutBadge.style.display = 'none';
      }
    }
  }
  
  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePriceAndBadge);
  } else {
    updatePriceAndBadge();
  }
  
  // Run after delays to catch dynamic content
  setTimeout(updatePriceAndBadge, 300);
  setTimeout(updatePriceAndBadge, 800);
  setTimeout(updatePriceAndBadge, 1500);
  
  // Watch for variant changes
  document.addEventListener('change', function(e) {
    if (e.target.matches('[name="id"]') || e.target.matches('.product-form__input')) {
      setTimeout(updatePriceAndBadge, 100);
    }
  });
  
  // Observe price container for changes
  const observer = new MutationObserver(function(mutations) {
    updatePriceAndBadge();
  });
  
  setTimeout(function() {
    const priceContainer = document.querySelector('.price');
    if (priceContainer) {
      observer.observe(priceContainer, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }, 1000);
  
})();

  } catch(e) { console.error(e); }
})();
})();
